﻿import { User } from 'shared/data/user';
import { UserDelegation } from 'runtime/data/userdelegation';

export class CurrentUserDelegation {
    delegateUser: User;
    userDelegation: UserDelegation;
}
